import router from './router'
import store from './store'
const whiteList = ['/login'] // no redirect whitelist
router.beforeEach(async (to, from, next) => {
  const token = store.state.user.token
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // 如果没有获取过用户信息就需要获取
      if (!store.getters.hasUserInfo) {
        const { permission } = await store.dispatch('user/getUserInfo')// 拿到用户权限
        const routes = await store.dispatch('permission/filterRoutes', permission.menus) // 根据权限筛选路由
        routes.forEach(route => {
          router.addRoute(route)
        })
        return next(to.path)
      }
      next()
    }
  } else {
    // 白名单可以直接跳转
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})
